import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import { Link } from 'gatsby';

export const Wrapper = styled.div`
  position: fixed;
  bottom: 30px;
  right: 7%;
  display: inline-flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  z-index: 1000;
  transform: ${props =>
    props.isVisible ? 'translateY(0)' : 'translateY(120%)'};
  opacity: ${props => (props.isVisible ? '1' : '0')};
  transition: all 0.3s ease-in-out;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  border: 2px solid #000;
  background: #000;
  cursor: pointer;
`;

export const StyledGatsbyLink = styled(Link)`
  font-size: 16px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  line-height: 22px;
  color: var(--Primary-Skychain, #4169e1);
  background: none;
  box-shadow: none;
  font-weight: 500;
  text-decoration: none;
`;

export const QRIcon = styled.img`
  width: 100%;
  height: 100px;
  aspect-ratio: 1/1;
  object-fit: contain;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;

export const Title = styled.div`
  width: 100%;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-family: 'Satoshi Variable Medium', sans-serif;
  font-weight: 900;
  line-height: 17.22px;
  word-wrap: break-word;
  ${media.md`
    font-size: 16px;
    line-height: 20px;
  `}
  ${media.lg`
    font-size: 18px;
    line-height: 22px;
  `}
`;

export const IconsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 100%;
`;

export const AppStoreIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
  filter: brightness(0) invert(1);
`;

export const PlayStoreIcon = styled.img`
  width: 14px;
  height: 14px;
  object-fit: contain;
  cursor: pointer;
  transition: transform 0.2s ease;
  filter: brightness(0) invert(1);
`;
